import client from "../client";

export const sendOtpSms = async ({
  userId,
  phoneNumber,
  language,
}: {
  userId: string;
  phoneNumber: string;
  language?: string;
}) => {
  return await client.post("/sendOtpSms", {
    userId,
    phoneNumber,
    recipientLanguage: language ?? "no",
  });
};

export const validatePhoneNumberWithOtp = async ({
  userId,
  phone,
  otp,
}: {
  userId: string;
  phone: string;
  otp: string;
}) => {
  return await client.post("/validatePhoneNumberWithOtp", {
    userId,
    phone,
    otp,
  });
};
